import { Collection, Document } from 'firestorter';

class StripeCustomerDocument extends Document {
  /**
   * A client's Stripe customer, narrowed to one connected account when one is given.
   *
   * A client holds one customer per account, so without the account this returns whichever the
   * index happens to order first — and pairing that with a different coach's account builds a
   * dashboard link that resolves to nothing.
   *
   * @param {string} userId The client.
   * @param {string} [stripeAccountId] The connected account the customer must belong to.
   * @return {Promise<StripeCustomerDocument|{}>} The customer, or an empty object when there is none.
   */
  static async getStripeCustomerByUserId(userId, stripeAccountId = '') {
    const collection = new Collection('/integrations/stripe/customers/',
      {
        query: (ref) => {
          const scoped = ref.where('user', '==', userId);
          return (stripeAccountId ? scoped.where('stripeAccountId', '==', stripeAccountId) : scoped).limit(1);
        },
        createDocument: (source, options) => new StripeCustomerDocument(source, options),
      });
    await this.init(collection);
    if (collection.hasDocs) {
      return collection.docs[0];
    }
    return {};
  }

  static async init(collection) {
    // eslint-disable-next-line no-param-reassign
    collection.mode = 'off';
    if (!collection.isLoading && !collection.isActive) {
      await collection.fetch();
    }
    await collection.ready();
    // eslint-disable-next-line no-param-reassign
    collection.mode = 'auto';
  }

  getCustomer() {
    return this.data.stripeCustomer;
  }
}

export default StripeCustomerDocument;
